<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable fullscreen>
      <v-form ref="UploadStudentForm" @submit.prevent>
        <v-card>
          <v-card-title class="d-flex align-center px-6 py-5">
            <span class="text-h5 font-weight-bold">{{ action }} Students</span>
            <v-spacer></v-spacer>
            <v-btn icon="mdi-close" variant="text" @click="closeD()"></v-btn>
          </v-card-title>
          <v-card-subtitle class="px-6 pb-4"
            >Add or import students into a batch</v-card-subtitle
          >

          <v-card-text class="px-6">
            <v-row>
              <v-col cols="12" md="6" v-if="entry_type">
                <v-autocomplete
                  v-model="batch_selected"
                  @update:modelValue="showAddBatch"
                  :rules="[formRules.required]"
                  :items="batchList"
                  item-value="id"
                  :item-title="
                    (item) =>
                      item.year != ''
                        ? `${item.name}  (${item.year})`
                        : `${item.name}`
                  "
                  label="Select Batch"
                  prepend-inner-icon="mdi-account-group-outline"
                  variant="outlined"
                  density="compact"
                  rounded="lg"
                  :color="$vuetify.theme.themes.light.inputColor"
                ></v-autocomplete>
                <v-autocomplete
                  v-if="entry_type == 2"
                  v-model="program_selected"
                  @update:modelValue="onProgramChange"
                  :rules="[formRules.required]"
                  :items="programsList"
                  item-value="abbr"
                  item-title="name"
                  label="Select Program"
                  prepend-inner-icon="mdi-account-group-outline"
                  variant="outlined"
                  density="compact"
                  rounded="lg"
                  :color="$vuetify.theme.themes.light.inputColor"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6" v-if="entry_type == 1">
                <v-file-input
                  @change="parseCSV()"
                  clearable
                  label="Upload Student List"
                  accept=".csv"
                  prepend-icon=""
                  prepend-inner-icon="mdi-file-upload-outline"
                  variant="outlined"
                  density="compact"
                  rounded="lg"
                  :color="$vuetify.theme.themes.light.inputColor"
                  v-model="csv_file"
                ></v-file-input>
              </v-col>
            </v-row>

            <v-card
              class="my-5 dt-container rounded-lg"
              elevation="0"
              border
              v-if="entry_type == 1"
            >
              <div
                class="d-flex flex-column align-center justify-center py-10"
                v-if="!parsed && csv_file"
              >
                <v-progress-circular
                  indeterminate
                  :color="$vuetify.theme.themes.light.submitBtns"
                  class="mb-3"
                ></v-progress-circular>
                <span class="text-body-2 text-medium-emphasis"
                  >Loading student list...</span
                >
              </div>
              <v-data-table
                v-if="parsed && csv_file"
                :headers="headers"
                :items="csv_results.data"
                :loading="loading"
                hover
                density="compact"
              >
                <template v-slot:[`item.bdate`]="{ item }">
                  {{ formatDate(item.bdate) }}
                </template>
              </v-data-table>
            </v-card>

            <v-card
              class="my-5 dt-container rounded-lg"
              elevation="0"
              border
              v-if="entry_type == 2"
            >
              <v-card-text class="d-flex justify-end pb-0">
                <v-btn
                  :color="$vuetify.theme.themes.light.submitBtns"
                  class="white--text"
                  density="comfortable"
                  variant="flat"
                  rounded="pill"
                  @click="addData()"
                >
                  <v-icon start>mdi-plus</v-icon>
                  Add Student
                </v-btn>
              </v-card-text>
              <v-data-table
                :headers="headers"
                :items="students_data"
                :loading="loading"
                hover
                density="compact"
              >
                <template v-slot:[`item.bdate`]="{ item }">
                  {{ formatDate(item.bdate) }}
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn
                    color="red"
                    class="white--text"
                    size="x-small"
                    @click="remove(item, index)"
                    rounded
                  >
                    remove
                  </v-btn>
                </template>
              </v-data-table>
            </v-card>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn
              variant="outlined"
              rounded="pill"
              color="error"
              @click="closeD()"
            >
              Cancel
            </v-btn>
            <v-btn
              :color="$vuetify.theme.themes.light.submitBtns"
              class="white--text"
              density="comfortable"
              variant="flat"
              rounded="pill"
              :disabled="btnLoading"
              :loading="btnLoading"
              @click="save()"
            >
              <v-icon start>mdi-check</v-icon>
              Add
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="entrytypeDialog" eager persistent max-width="480">
      <v-card class="rounded-xl">
        <v-card-title class="d-flex align-center px-6 pt-5">
          <span class="text-h6 font-weight-bold">{{ action }} Students</span>
          <v-spacer></v-spacer>
          <v-btn
            icon="mdi-close"
            variant="text"
            @click="entrytypeDialog = false"
          ></v-btn>
        </v-card-title>
        <v-card-subtitle class="px-6 pb-2"
          >Choose how you'd like to add students</v-card-subtitle
        >

        <v-card-text class="px-6 pb-6">
          <v-row dense>
            <v-col cols="6">
              <v-card
                rounded="lg"
                class="pa-5 text-center entry-option"
                :style="{
                  backgroundColor: $vuetify.theme.themes.light.submitBtns,
                }"
                @click="entrySelect(2)"
                style="cursor: pointer"
              >
                <v-icon size="32" color="white">mdi-file-upload-outline</v-icon>
                <div class="text-body-2 font-weight-bold text-white mt-3">
                  Batch Upload
                </div>
                <div
                  class="text-caption"
                  style="color: rgba(255, 255, 255, 0.85)"
                >
                  Import via CSV file
                </div>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card
                rounded="lg"
                class="pa-5 text-center entry-option"
                :style="{
                  backgroundColor: $vuetify.theme.themes.light.inputColor,
                }"
                @click="entrySelect(2)"
                style="cursor: pointer"
              >
                <v-icon size="32" color="white"
                  >mdi-account-plus-outline</v-icon
                >
                <div class="text-body-2 font-weight-bold text-white mt-3">
                  Manual Entry
                </div>
                <div
                  class="text-caption"
                  style="color: rgba(255, 255, 255, 0.85)"
                >
                  Add students one by one
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="studentDialog" eager persistent max-width="500">
      <v-form ref="ManualStudentForm" @submit.prevent>
        <v-card class="rounded-xl">
          <v-card-title class="d-flex align-center px-6 pt-5">
            <span class="text-h6 font-weight-bold">
              {{ internal_action == "Add" ? "Add New" : "Update" }} Student
            </span>
            <v-spacer></v-spacer>
            <v-btn
              icon="mdi-close"
              variant="text"
              @click="studentDialog = false"
            ></v-btn>
          </v-card-title>

          <v-card-text class="mt-2 px-6">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="student_id"
                  @keyup="findStudent"
                  :rules="[formRules.required]"
                  label="Student School Id"
                  prepend-inner-icon="mdi-identifier"
                  variant="outlined"
                  density="compact"
                  rounded="lg"
                  :color="$vuetify.theme.themes.light.inputColor"
                ></v-text-field>
                <div class="d-flex align-center text-caption" v-if="searching">
                  <v-progress-circular
                    indeterminate
                    size="14"
                    width="2"
                    class="mr-2"
                  ></v-progress-circular>
                  Searching...
                </div>
                <v-chip
                  v-if="search_output == 'found'"
                  size="small"
                  color="warning"
                  variant="tonal"
                  prepend-icon="mdi-alert-circle-outline"
                  class="mt-1"
                >
                  Student already existed
                </v-chip>
                <v-chip
                  v-if="search_output == 'not found'"
                  size="small"
                  color="success"
                  variant="tonal"
                  prepend-icon="mdi-information-outline"
                  class="mt-1"
                >
                  Student not found in records
                </v-chip>
              </v-col>

              <v-col cols="12" v-if="search_output == 'not found'">
                <v-text-field
                  v-model="email"
                  :rules="
                    search_output == 'not found' ? [formRules.required] : []
                  "
                  label="Student Email"
                  prepend-inner-icon="mdi-email-outline"
                  variant="outlined"
                  density="compact"
                  rounded="lg"
                  :color="$vuetify.theme.themes.light.inputColor"
                />
              </v-col>
              <v-col cols="12" v-if="search_output == 'not found'">
                <v-text-field
                  v-model="fname"
                  :rules="
                    search_output == 'not found' ? [formRules.required] : []
                  "
                  label="Student First Name"
                  prepend-inner-icon="mdi-account-outline"
                  variant="outlined"
                  density="compact"
                  rounded="lg"
                  :color="$vuetify.theme.themes.light.inputColor"
                />
              </v-col>
              <v-col cols="12" v-if="search_output == 'not found'">
                <v-text-field
                  v-model="mname"
                  label="Student Middle Name"
                  prepend-inner-icon="mdi-account-outline"
                  variant="outlined"
                  density="compact"
                  rounded="lg"
                  :color="$vuetify.theme.themes.light.inputColor"
                />
              </v-col>
              <v-col cols="12" v-if="search_output == 'not found'">
                <v-text-field
                  v-model="lname"
                  :rules="
                    search_output == 'not found' ? [formRules.required] : []
                  "
                  label="Student Last Name"
                  prepend-inner-icon="mdi-account-outline"
                  variant="outlined"
                  density="compact"
                  rounded="lg"
                  :color="$vuetify.theme.themes.light.inputColor"
                />
              </v-col>
              <v-col cols="12" v-if="search_output == 'not found'">
                <v-text-field
                  v-model="suffix"
                  label="Student Suffix"
                  prepend-inner-icon="mdi-account-outline"
                  variant="outlined"
                  density="compact"
                  rounded="lg"
                  :color="$vuetify.theme.themes.light.inputColor"
                />
              </v-col>
              <v-col cols="12" v-if="search_output == 'not found'">
                <v-select
                  v-model="sex"
                  :items="['Male', 'Female']"
                  label="Sex"
                  prepend-inner-icon="mdi-gender-male-female"
                  variant="outlined"
                  density="compact"
                  rounded="lg"
                  class="mb-2"
                  :color="$vuetify.theme.themes.light.inputColor"
                />
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions class="pa-4" v-if="search_output == 'not found'">
            <v-spacer></v-spacer>
            <v-btn
              variant="outlined"
              rounded="pill"
              color="error"
              @click="studentDialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
              :color="$vuetify.theme.themes.light.submitBtns"
              class="white--text"
              density="comfortable"
              variant="flat"
              rounded="pill"
              @click="saveData()"
            >
              <v-icon start>mdi-check</v-icon>
              Add
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="dialogConfirmDelete" max-width="500">
      <v-card>
        <v-card-title class="text-h6">Warning</v-card-title>
        <v-card-text class="text-body-1">
          Are you sure you want to remove this student in the list?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="dialogConfirmDelete = false"
            >Cancel</v-btn
          >
          <v-btn color="error" class="white--text" @click="proceedDelete"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <SkillAssessmentBatchDialog
      :data="batch_group"
      :action="'Add'"
      :batchToAdd="2"
    />
    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import eventBus from "@/eventBus";
import Papa from "papaparse";
import SkillAssessmentBatchDialog from "./SkillAssessment/SkillAssessmentBatchDialog.vue";
export default {
  props: {
    data: Object,
    action: String,
  },
  data() {
    return {
      dialogConfirmDelete: false,
      dialog: false,
      itemToDelete: null,
      indexToDelete: null,
      exceldata: [],
      program_id: null,
      email: null,
      address: null,
      batch_selected: null,
      batch: null,
      batch_year: null,
      batch_group: null,
      batchList: [],
      program_tied_id: null,
      btnLoading: false,
      loading: false,
      csv_results: [],
      csv_file: null,
      parsed: false,
      headers: [
        { title: "School Id", value: "school_id", align: "start" },
        { title: "First Name", value: "fname", align: "start" },
        { title: "Middle Name", value: "mname", align: "start" },
        { title: "Last Name", value: "lname", align: "start" },
        { title: "Suffix", value: "suffix", align: "start" },
        { title: "Sex", value: "sex", align: "start" },
        { title: "Email", value: "email", align: "start" },
      ],
      programsList: [],
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },

      entry_type: null,
      entrytypeDialog: false,
      studentDialog: false,
      internal_action: null,
      student_id: null,
      students_data: [],
      debounceTimer: null,
      fname: null,
      mname: null,
      lname: null,
      suffix: null,
      sex: null,
      searching: false,
      search_output: null,
      program_selected: null,
    };
  },
  components: {
    SkillAssessmentBatchDialog,
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        console.log(data);
        this.getPrograms();
        this.fetched_data = [];
        this.students_data = [];
        this.entry_type = null;
        this.entrytypeDialog = true;
        this.initialize();
        this.$refs.UploadStudentForm.resetValidation();
      },
      deep: true,
    },
  },
  computed: {
    getProgramName() {
      let name = "";
      for (let i = 0; i < this.programsList.length; i++) {
        if (this.programsList[i].id == this.$store.state.user.program_id)
          name = this.programsList[i].name;
      }
      return name;
    },
  },

  mounted() {
    eventBus.on("closeSkillAssessmentBatchDialog", () => {
      console.log("vcalled me");
      this.getBatchList();
    });
  },
  beforeUnmount() {
    eventBus.off("closeSkillAssessmentBatchDialog");
  },
  methods: {
    initialize() {
      this.getBatchList();
      // this.getPrograms();
    },

    showAddBatch() {
      console.log("SLEE", this.batch_selected);
      this.reset();
      if (this.batch_selected == -1) {
        this.batch_group = { id: null };
      }
    },

    remove(item, index) {
      this.itemToDelete = item;
      this.indexToDelete = index;
      this.dialogConfirmDelete = true;
    },

    proceedDelete() {
      if (this.entry_type == 1) {
        this.fetched_data.splice(this.indexToDelete, 1);
      }
      if (this.entry_type == 2) {
        this.students_data.splice(this.indexToDelete, 1);
      }

      this.dialogConfirmDelete = false;
      this.fadeAwayMessage.show = true;
      this.fadeAwayMessage.type = "success";
      this.fadeAwayMessage.message = "Removed successfully";
      this.fadeAwayMessage.header = "System Message";
      this.itemToDelete = null;
      this.indexToDelete = null;
    },

    entrySelect(val) {
      this.entry_type = val;
      if (val == 2) {
        let check = this.headers.find((data) => data.title == "Actions");
        if (!check) {
          this.headers.push({
            title: "Actions",
            value: "actions",
            align: "center",
            sortable: false,
            width: 200,
          });
        }
      }
      this.entrytypeDialog = false;
    },

    reset() {
      if (this.entry_type == 1) {
        this.csv_results = [];
      }
      if (this.entry_type == 2) {
        this.students_data = [];
      }

      this.program_selected = null;
    },

    onProgramChange() {
      if (this.entry_type == 1) {
        this.csv_results = [];
      }
      if (this.entry_type == 2) {
        this.students_data = [];
      }
    },
    parseCSV() {
      Papa.parse(this.csv_file, {
        header: true,
        skipEmptyLines: true,
        complete: function (results) {
          this.csv_results = results;
          this.parsed = true;
        }.bind(this),
      });
    },

    async save() {
      if (this.entry_type == 1) {
        if (this.csv_results.data.length > 0) {
          this.btnLoading = true;
          let data = {
            batch_id: this.batch_selected,
            list: JSON.stringify(this.csv_results.data),
          };
          this.axiosCall("/student/bulk-create", "POST", data).then((res) => {
            if (res.data.status == 201) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
              this.btnLoading = false;
              this.closeD();
            } else {
              this.btnLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
            }
          });
        }
      } else {
        if (this.students_data.length > 0) {
          this.btnLoading = true;
          let data = {
            batch_id: this.batch_selected,
            list: JSON.stringify(this.students_data),
          };
          this.axiosCall("/student/bulk-create", "POST", data).then((res) => {
            if (res.data.status == 201) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
              this.btnLoading = false;
              this.closeD();
            } else {
              this.btnLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
            }
          });
        }
      }
    },

    addData() {
      if (!this.batch_selected) {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.message = "Please select batch";
        this.fadeAwayMessage.header = "System Message";
        return;
      } else {
        this.searching = false;
        this.search_output = null;
        this.student_id = null;
        this.studentDialog = true;
        this.internal_action = "Add";
      }
    },

    closeD() {
      eventBus.emit("closeUploadStudentDialog", true);
      this.dialog = false;
    },

    findStudent() {
      let val = this.student_id;
      clearTimeout(this.debounceTimer);
      console.log(val);
      this.debounceTimer = setTimeout(() => {
        if (val) {
          this.getData(val);
        }
      }, 2000);
    },

    saveData() {
      if (this.$refs.ManualStudentForm.validate()) {
        this.students_data.push({
          school_id: this.student_id,
          fname: this.fname,
          mname: this.mname,
          lname: this.lname,
          suffix: this.suffix,
          sex: this.sex,
          email: this.email,
          program: this.program_selected,
        });

        this.studentDialog = false;
        this.student_id = null;
        this.fname = null;
        this.mname = null;
        this.lname = null;
        this.suffix = null;
        this.email = null;
      }
    },

    getData(data) {
      this.searching = true;
      this.axiosCall(
        "/student/findByBatchAndSchoolId/" + this.batch_selected + "/" + data,
        "GET",
      ).then((res) => {
        if (res.data) {
          this.searching = false;
          this.search_output = "found";
        } else {
          this.searching = false;
          this.search_output = "not found";
        }
        console.log("retrun", res.data);
      });
    },

    getPrograms() {
      this.axiosCall("/program/getProgramsByInstitute", "GET").then((res) => {
        console.log(res.data);
        this.programsList = res.data;
      });
    },
    getBatchList() {
      this.batch_selected = null;
      this.axiosCall("/student/get-batch-list", "GET").then((res) => {
        this.batchList = res.data;
        this.batchList.push({ id: -1, name: "Add new Batch", year: "" });
      });
    },
  },
};
</script>

<style scoped>
.entry-option {
  transition: box-shadow 0.15s ease, transform 0.1s ease;
}
.entry-option:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}
.dt-container {
  overflow: hidden;
}
</style>
